import {alias, createModelSchema} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";

export class SnapshotModel extends BaseObject {

    constructor() {
        super();
        this._checksum = "";
        this._created = "";
        this._id= "";
        this._level= 0;
        this._player_id= "";
        this._user_id= "";
        this._version= "";
        this._name= "";
        this._info = "";
    }

    get info() {return this._info;}
    set info(value) {this._info = value;}

    get name() {return this._name;}
    set name(value) {this._name = value;}

    get checksum() {return this._checksum;}
    set checksum(value) {this._checksum = value;}

    get created() {return this._created;}
    set created(value) {this._created = value;}

    get id() {return this._id;}
    set id(value) {this._id = value;}

    get level() {return this._level;}
    set level(value) {this._level = value;}

    get player_id() {return this._player_id;}
    set player_id(value) {this._player_id = value;}

    get user_id() {return this._user_id;}
    set user_id(value) {this._user_id = value;}

    get version() {return this._version;}
    set version(value) {this._version = value;}

    copy() {
        return super.copy();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SnapshotModel());
        } else if (target instanceof SnapshotModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SnapshotModel, {
    _info: alias("info", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _checksum: alias("checksum", Schema.primitive()),
    _created: alias("created", Schema.primitive()),
    _id: alias("id", Schema.primitive()),
    _level: alias("level", Schema.primitive()),
    _player_id: alias("player_id", Schema.primitive()),
    _user_id: alias("user_id", Schema.primitive()),
    _version: alias("version", Schema.primitive()),
});